exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input_noborder {\n  border: none; }\n\n.dd-requireTrue {\n  border-color: grey; }\n\n.dd-requireFalse {\n  border-color: #dadfe6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/inputs/spro-dropdownlist/spro-dropdownlist.component.scss
// module id = ../../../../../src/app/sproLib/spro/inputs/spro-dropdownlist/spro-dropdownlist.component.scss
// module chunks = main